import {
	Flex,
	FormControl,
	FormErrorMessage,
	FormLabel,
	forwardRef,
	Select as ChakraSelect,
	SelectProps as ChakraSelectProps,
	Text,
} from "@chakra-ui/react";
import { ForwardRefRenderFunction } from "react";
import { FieldError } from "react-hook-form";
// import { IconBaseProps } from "react-icons";

interface OptionProps {
	value: number;
	label: string;
}
interface InputSelectProps extends ChakraSelectProps {
	name: string;
	label?: string;
	// icon?: React.ComponentType<IconBaseProps>;
	options: OptionProps[];
	error?: FieldError;
}

const SelectBase: ForwardRefRenderFunction<HTMLSelectElement, InputSelectProps> = (
	{ name, label, icon, options, error = null, ...rest },
	ref
) => {
	return (
		<FormControl isInvalid={!!error}>
			<FormLabel
				htmlFor={name}
				pb="0" mb="1" fontWeight="400"
				display={rest.display}
				visibility={rest.visibility}
			>
				<Flex align="center">
					<Text fontSize="18">{label}</Text>
				</Flex>
			</FormLabel>

			<ChakraSelect
				name={name}
				id={name}
				focusBorderColor="blue.100"
				variant="filled"
				_hover={{ bg: 'gray.200' }}
				size="lg"
				ref={ref}
				{...rest}
			>
				<option value="" disabled></option>
				
				{options.map(option => (
					<option key={option.value} value={option.value}>{option.label}</option>
				))}
			</ChakraSelect>

			{!!error && (
				<FormErrorMessage>
					{error.message}
				</FormErrorMessage>
			)}
		</FormControl>
	)
}

export const Select = forwardRef(SelectBase);